import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

export const DashboardFilterSkeleton: React.FC = () => (
  <Box sx={{ marginBottom: '20px' }}>
    <Stack alignItems="center" direction="row" gap="8px" sx={{ py: '12px' }}>
      <Skeleton height={32} variant="rounded" width={100} />
    </Stack>
    <Stack alignItems="center" direction="row" gap="8px" sx={{ mt: '24px' }}>
      <Skeleton height={32} sx={{ marginTop: '12px' }} variant="rounded" width="100%" />
    </Stack>
  </Box>
);
